module.exports = __webpack_public_path__ + "static/media/activity-content-five.5182b1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/activity/components/images/activity-content-five.png
// module id = 912
// module chunks = 0